import type { ReactNode } from 'react'
import { Masthead } from './Masthead'

/** Signed-out / loading frame: the branded masthead + a centered content
 *  column. The signed-in app uses AppShell (desktop sidebar, mobile bottom
 *  nav) instead. */
export function Shell({ children, headerRight }: { children: ReactNode; headerRight?: ReactNode }) {
  return (
    <div className="min-h-screen bg-canvas">
      <Masthead headerRight={headerRight} />
      <main className="mx-auto w-full max-w-2xl px-4 py-5">{children}</main>
    </div>
  )
}
